export default [
  {
    path: '/admin',
    name: 'admin',
    meta: { title: "admin" },
    component: () => import('@/views/pages/admin/index.vue'),
  },
  {
    path: '/admin/record/system/:codeID',
    name: 'system',
    meta: { title: "用户代码" },
    component: () => import('@/views/pages/admin/code.vue')
  },
  {
    path: '/admin/record/user/:codeID',
    name: 'user',
    meta: { title: "用户代码" },
    component: () => import('@/views/pages/admin/code.vue')
  },
  {
    path: '/admin',
    component: () => import('@/views/pages/admin/index.vue'),
    redirect: '/admin/',
    children: [
      {
        path: 'add',
        name: 'add',
        meta: { title: "添加用户" },
        component: () => import('@/views/pages/admin/add_user.vue')
      },
      {
        path: 'wiki',
        name: 'wiki',
        meta: { title: "wiki" },
        component: () => import('@/views/pages/admin/wiki.vue')
      },
      {
        path: 'docs',
        name: 'docs',
        meta: { title: "资料管理" },
        component: () => import('@/views/pages/admin/docs.vue')
      },
      {
        path: 'organization',
        name: 'organization',
        meta: { title: "机构注册" },
        component: () => import('@/views/pages/admin/organization.vue')
      },
      {
        path: 'statistic',
        name: 'adminStatistic',
        meta: { title: "数据统计" },
        component: () => import('@/views/pages/admin/statistic.vue')
      },
      {
        path: 'user',
        name: 'adminUser',
        meta: { title: "用户管理" },
        component: () => import('@/views/pages/admin/user.vue')
      },
      {
        path: 'setting',
        name: 'adminSetting',
        meta: { title: "设置中心" },
        component: () => import('@/views/pages/admin/setting.vue')
      },
      {
        path: 'board',
        name: 'board',
        meta: { title: "榜单管理" },
        component: () => import('@/views/pages/admin/board.vue')
      },
      {
        path: 'notifications',
        name: 'coursebackNotifications',
        meta: { title: "公告管理" },
        component: () => import('@/views/pages/courseBack/notifications/index.vue')
      },
      // 比赛
      {
        path: 'contest/list',
        name: 'adminContest',
        meta: { title: "比赛管理" },
        component: () => import('@/views/pages/admin/contest.vue')
      },
      {
        path: 'contest/category',
        name: 'contest',
        meta: { title: "标签管理" },
        component: () => import('@/views/pages/admin/category.vue')
      },
      // 课程
      {
        path: 'course/list',
        name: 'adminCourse',
        meta: { title: "课程管理" },
        component: () => import('@/views/pages/admin/course.vue')
      },
      {
        path: 'course/category',
        name: 'course',
        meta: { title: "标签管理" },
        component: () => import('@/views/pages/admin/category.vue')
      },
      // 提交记录
      {
        path: 'record/test',
        name: 'test',
        meta: { title: "用户题库" },
        component: () => import('@/views/pages/admin/record.vue')
      },
      {
        path: 'record/stest',
        name: 'stest',
        meta: { title: "用户题库" },
        component: () => import('@/views/pages/admin/record.vue')
      },
      {
        path: 'record/user',
        name: 'user',
        meta: { title: "用户题库" },
        component: () => import('@/views/pages/admin/record.vue')
      },
      {
        path: 'record/system',
        name: 'system',
        meta: { title: "系统题库" },
        component: () => import('@/views/pages/admin/record.vue')
      },
      // 题库
      {
        path: 'problem/category',
        name: 'problem',
        meta: { title: "标签管理" },
        component: () => import('@/views/pages/admin/category.vue')
      },
      {
        path: 'problem/user',
        name: 'user',
        meta: { title: "用户题库" },
        component: () => import('@/views/pages/admin/user_problem.vue')
      },
      {
        path: 'problem/system',
        name: 'adminProblem',
        meta: { title: "系统题库" },
        component: () => import('@/views/pages/admin/system_problem.vue')
      }
    ]
  },
  {
    path: '/admin/problem/user/:problemID',
    name: 'user',
    component: () => import('@/views/pages/problem/problem/index.vue'),
    redirect: '/admin/problem/user/:problemID',
    children: [
      {
        path: '',
        name: '',
        meta: { title: "题目描述" },
        component: () => import('@/views/pages/problem/problem/7_code/title.vue'),
      },
      {
        path: 'comments',
        name: 'problemComments',
        meta: { title: "评论" },
        component: () => import('@/views/pages/problem/problem/7_code/comments.vue'),
      },
      {
        path: 'solution',
        name: 'problemSolution',
        meta: { title: "题解" },
        component: () => import('@/views/pages/problem/problem/7_code/solution.vue'),
      },
      {
        path: 'result',
        name: 'problemResult',
        meta: { title: "题解" },
        component: () => import('@/views/pages/problem/problem/7_code/result.vue'),
      },
      {
        path: 'submissions',
        name: 'problemSubmissions',
        meta: { title: "提交记录" },
        component: () => import('@/views/pages/problem/problem/7_code/submissions.vue'),
      }
    ]
  }
]
